import { toItem as toPublicMediaItem } from '../../public/mappers/item';
import { toItem as toShutterStockItem } from '../../shutterstock/mappers/item';
import { toItem as toUnsplashItem } from '../../unsplash/mappers/item';
import { Provider } from '../constants';
export function toItem(item, settings, thumbnailSizes) {
  const {
    data,
    provider
  } = item;
  return provider === Provider.WixPublicMedia ? toPublicMediaItem(data, settings.publicMedia, thumbnailSizes.publicMedia) : provider === Provider.Unsplash ? toUnsplashItem(data) : provider === Provider.Shutterstock ? toShutterStockItem(data) : null;
}